/*
 * Created Date: 16-01-2024, 9:41:04 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

const basePath = '/workspace/team'
export const TRANSLATION_WORKSPACE_TEAM = 'workspace/team'
export const ROUTER_WORKSPACE_TEAM = {
	member_list: `${basePath}/members`,
	member_role: `${basePath}/member-role`,
	student: `${basePath}/student`
}
